import DeviceLogViewer from '../../../../components/DeviceLogs/DeviceLogViewer'

export default function LogsSection({ device }) {
  return <DeviceLogViewer deviceId={device.id} />
}
